@if (selected(); as image) {
    <div class="product-gallery-main">
        @if (statusLabel(); as label) {
            <sirius-chip class="product-gallery-label" [config]="label" data-cy="gallery-label"></sirius-chip>
        }
        <button
            type="button"
            class="product-gallery-image"
            [attr.aria-label]="'gallery.viewFullSizeImage' | translate: { title: image.title }"
            (click)="openLightbox()"
            data-cy="gallery-main-image"
        >
            <sirius-image-item
                [image]="image"
                [imageData]="imageData()"
                [autocrop]="true"
                objectFit="cover"
                fetchPriority="high"
            ></sirius-image-item>
        </button>
    </div>
}

@if (hasThumbnails()) {
    <div class="product-gallery-thumbnails" role="radiogroup" [attr.aria-label]="'gallery.thumbnails' | translate">
        @for (image of images(); track $index) {
            <button
                #thumbnailButton
                type="button"
                class="product-gallery-thumbnail"
                role="radio"
                [class.is-selected]="$index === selectedIndex()"
                [attr.aria-checked]="$index === selectedIndex()"
                [attr.aria-label]="image.title"
                [tabindex]="$index === selectedIndex() ? 0 : -1"
                (click)="select($index)"
                (keydown)="onKeydown($event, $index)"
            >
                <sirius-image-item
                    [image]="image"
                    [imageData]="thumbnailImageData()"
                    [autocrop]="true"
                    objectFit="cover"
                    alt=""
                ></sirius-image-item>
            </button>
        }
    </div>
}

@if (lightboxOpen()) {
    <sirius-media-collection-modal
        variant="dark"
        [items]="images()"
        [startIndex]="selectedIndex()"
        [showDescription]="true"
        (closeEvent)="onLightboxClose($event)"
    ></sirius-media-collection-modal>
}
